import { Collapse } from 'antd';
import VideoCard from './VideoCard';

const ModuleCollapse = ({header, children, ...props}) => {
    return <Collapse.Panel header={header} {...props}>
                {children}
            </Collapse.Panel>
}

export default ModuleCollapse;